var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-navbar',{attrs:{"type":"light","variant":"light"}},[_c('b-container',[_c('b-navbar-brand',{attrs:{"href":"https://aloftdata.eu"}},[_vm._v(" Aloft ")]),_c('span',{staticClass:"navbar-text"},[_vm._v("Visualize bird movement data from European weather radars")]),_c('b-navbar-nav',{staticClass:"ml-auto"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }